import React from 'react';
import { StyledBrand, StyledBrandLogo, StyledBrandTitle } from './styledBrand';

export interface IBrandProps {
  href?: string;
  title: string;
  logo: string;
  size?: 'md' | 'lg';
  alt?: string;
  otherProps?: Record<string, unknown>;
}

const Brand = ({ href, title, logo, size, alt, otherProps }: IBrandProps): JSX.Element => (
  <StyledBrand href={href} {...otherProps}>
    <>
      <StyledBrandLogo src={logo} alt={alt || title} size={size} data-test-id="NavBarBrand-logo" />
      <StyledBrandTitle data-test-id="NavBarBrand-title">{title}</StyledBrandTitle>
    </>
  </StyledBrand>
);

export default Brand;
